import {DropdownMenu} from 'letrus-ui';
import {useEffect, useState} from 'react';

export interface BarSavedAtProps {
  hideChangeButtons: boolean;
  userSavedAt: string | null;
  onClickRestore: () => void;
  onClickSave: () => void;
}

const BarSavedAt: React.FC<BarSavedAtProps> = ({
  hideChangeButtons,
  userSavedAt,
  onClickRestore,
  onClickSave,
}) => {
  const [clickedOnSave, setClickedOnSave] = useState(false);

  useEffect(() => {
    // this is necessary because the onClick function
    //  looses context inside the DropdowMenu component
    if (clickedOnSave) {
      onClickSave();
      setClickedOnSave(false);
    }
  }, [clickedOnSave]);

  return hideChangeButtons ? (
    <span>{userSavedAt || ''}</span>
  ) : (
    <DropdownMenu
      title={userSavedAt || ''}
      items={[
        {
          onClick: () => {
            setClickedOnSave(!clickedOnSave);
          },
          text: 'Salvar',
          id: 1,
        },
        {
          onClick: onClickRestore,
          text: 'Recuperar redações salvas',
          id: 2,
        },
      ]}
    />
  );
};

export default BarSavedAt;
